import { ArrowRight, TrendingUp, Gauge, Smartphone, Accessibility, FileText, MousePointerClick, ShieldCheck, BrainCircuit } from "lucide-react";
import { motion } from "framer-motion";
import { ScoreRing } from "@/components/ScoreRing";
import { scoreTone } from "@/lib/api";
import { useAnalyzer } from "@/context/AnalyzerContext";

const DEMO = [
  { key: "SEO", icon: TrendingUp, score: 72 },
  { key: "Performance", icon: Gauge, score: 61 },
  { key: "Mobile", icon: Smartphone, score: 84 },
  { key: "Accessibility", icon: Accessibility, score: 69 },
  { key: "Content", icon: FileText, score: 64 },
  { key: "Conversion", icon: MousePointerClick, score: 48 },
  { key: "Security", icon: ShieldCheck, score: 86 },
  { key: "AI Readiness", icon: BrainCircuit, score: 32 },
];

export default function HeroScoreCard() {
  const { analyze } = useAnalyzer();

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className="bg-white rounded-2xl soft-shadow-lg border border-slate-100 p-6 md:p-7"
      data-testid="hero-score-card"
    >
      <div className="flex items-center justify-between mb-2">
        <span className="font-heading font-bold text-lg text-slate-900">WebsiteTech Score</span>
        <span className="font-mono text-xs text-slate-400">example.com</span>
      </div>
      <div className="mb-5 inline-flex items-center gap-1.5 bg-amber-50 border border-amber-200 text-amber-800 text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full" data-testid="hero-score-demo-label">
        <span className="w-1.5 h-1.5 rounded-full bg-amber-500" /> Illustrative demo data
      </div>

      <div className="flex items-center gap-6">
        <ScoreRing score={68} size={150} stroke={11} />
        <div>
          <p className="font-heading text-2xl font-bold text-slate-900 leading-tight">21 Opportunities<br />Identified</p>
          <button onClick={() => analyze("https://example.com")} className="btn-primary rounded-lg px-5 py-2.5 mt-4 flex items-center gap-2 text-sm" data-testid="see-full-report">
            See Full Report <ArrowRight size={15} />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-3 mt-6">
        {DEMO.map((d) => {
          const tone = scoreTone(d.score);
          const Icon = d.icon;
          return (
            <div key={d.key} className="border border-slate-200 rounded-xl p-3 text-center">
              <Icon size={18} className="mx-auto text-slate-400" />
              <p className="text-[10px] font-semibold text-slate-500 mt-1.5 leading-tight">{d.key}</p>
              <p className="font-heading font-bold text-xl mt-0.5" style={{ color: tone.color }}>{d.score}</p>
            </div>
          );
        })}
      </div>
    </motion.div>
  );
}
